import '@innovatrics/dot-document-auto-capture';
import type { DocumentConfiguration, HTMLDocumentCaptureElement } from '@innovatrics/dot-document-auto-capture';

import { memo, useEffect } from 'react';

/*
 * When component is initialized, wasm directory will be fetched from http://localhost:3000/wasm.
 * That's why wasm directory need to be placed in root of public directory.
 */

const DocumentCameraInner = (props: DocumentConfiguration) => {
  useEffect(() => {
    // 2. Init existed custom web-component
    const documentAutoCaptureHTMLElement = document.getElementById(
      'x-dot-document-auto-capture',
    ) as HTMLDocumentCaptureElement | null;

    if (documentAutoCaptureHTMLElement) {
      documentAutoCaptureHTMLElement.configuration = props;
    }
  });

  // 1. Return empty custom web-component html TAG
  return <x-dot-document-auto-capture id="x-dot-document-auto-capture" />;
};

export const DocumentCamera = memo(DocumentCameraInner);
